import script from "./CompanyTeamListView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyTeamListView.vue?vue&type=script&setup=true&lang=js"

import "./CompanyTeamListView.vue?vue&type=style&index=0&id=32cebadc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32cebadc"]])

export default __exports__